import script from "./MediaSettingsTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./MediaSettingsTabs.vue?vue&type=script&setup=true&lang=ts"

import "./MediaSettingsTabs.vue?vue&type=style&index=0&id=7f087837&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f087837"]])

export default __exports__